import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { MarksModel as Model } from './Model'

export const MODULE_NAME = 'marks-marks'

export const MARKS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
  UPLOAD: `${MODULE_NAME}.upload`,
  ACTIONS: `${MODULE_NAME}.actions`,
} as const

export const MENU = {
  id: MARKS_ROUTES.LAYOUT,
  route: { name: MARKS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-book-open-blank-variant',
} as const

export const createMarksModal = (
  parent: Vue,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "MarksModal" */
    './components/Modals/MarksModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

export const createMarksFileUploadModal = (
  parent: Vue,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "MarksFileUpload" */
    './components/Modals/MarksFileUpload.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}

